import { RewardCategory } from '@/types';
import { createToaster } from '@chakra-ui/react';
import jackpotIcon from '/assets/daily-spin/jackpot-reward.svg';
import nothingIcon from '/assets/daily-spin/nothing-reward.svg';
import plumeIcon from '/assets/daily-spin/plume-token-reward.svg';
import ppIcon from '/assets/daily-spin/pp-reward.svg';
import ticketsIcon from '/assets/daily-spin/raffle-ticket-reward.svg';
import treasureChestIcon from '/assets/daily-spin/treasure-chest.svg';

// Define all possible rewards
export const REWARD_CATEGORY_METADATA = {
  [RewardCategory.NotYetSpun]: {
    title: 'A Reward Awaits You',
    rewardCurrency: () => RewardCategory.NotYetSpun,
    rewardShorthand: '',
    color: 'white',
    icon: treasureChestIcon,
    message: "Spin the wheel to unlock today's reward!",
    pillColor: '#47354E',
    bgColor: '#E9F0F3',
  },
  [RewardCategory.Jackpot]: {
    title: 'You Just Hit a Jackpot!',
    rewardCurrency: (amount: bigint = BigInt(0)) => `${RewardCategory.PlumeToken}${amount === BigInt(1) ? '' : 's'}`,
    rewardShorthand: 'PLUME',
    color: 'white',
    icon: jackpotIcon,
    message: 'Time to post the gains screenshot',
    pillColor: '#47354E',
    bgColor: '#F4EAF8',
  },
  [RewardCategory.PP]: {
    title: 'Great Spin!',
    rewardCurrency: () => 'Plume Points',
    rewardShorthand: 'PP',
    color: 'white',
    icon: ppIcon,
    message: 'Your points will be added to your account at midnight UTC',
    pillColor: '#004038',
    bgColor: '#E9F0F3',
  },
  [RewardCategory.RaffleTicket]: {
    title: 'Great Spin!',
    rewardCurrency: (amount: bigint = BigInt(0)) => `${RewardCategory.RaffleTicket}${amount === BigInt(1) ? '' : 's'}`,
    rewardShorthand: 'Tickets',
    color: 'white',
    icon: ticketsIcon,
    message: '',
    pillColor: '#002755',
    bgColor: '#E9F0F3',
  },
  [RewardCategory.PlumeToken]: {
    title: "It ain't much but it's honest work!",
    rewardCurrency: (amount: bigint = BigInt(0)) => `${RewardCategory.PlumeToken}${amount === BigInt(1) ? '' : 's'}`,
    rewardShorthand: 'PLUME',
    color: 'white',
    icon: plumeIcon,
    message: '',
    pillColor: '#004038',
    bgColor: '#E9F0F3',
  },
  [RewardCategory.Nothing]: {
    title: 'WAGMI... But Not Today',
    rewardCurrency: () => RewardCategory.Nothing,
    rewardShorthand: '',
    color: 'white',
    icon: nothingIcon,
    message: '',
    pillColor: '#747474',
    bgColor: '#F0F0F0',
  },
};
export const dailySpinToaster = createToaster({
  placement: 'top-end',
  pauseOnPageIdle: true,
});
